const WORDS = ["BASEBALL", "ACTION", "MEMORIES"];

const Track = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex w-max shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display text-4xl tracking-wider text-white/15 md:text-6xl">
          {w}
        </span>
        <span className="mx-8 inline-block h-2.5 w-2.5 rounded-full bg-gradient-to-r from-accent to-accentlight md:mx-12" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-ink py-6 md:py-8"
      data-testid="marquee-band"
    >
      <div className="flex w-max animate-marquee">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
